import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Sentence from './Sentence';
import Honeycomb from './HoneyComb/Honeycomb';
import { useState } from 'react';
import { Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { addOriginalSentence } from '../database/addOriginalSentence';
import { teacherIdState } from '../globalStates/general/teacherId';
import { getOriginalSentence } from '../database/getOriginalSentence';
import { useEffect } from 'react';
import { deleteOriginalSentence } from '../database/deleteOriginalSentence';
import { LoadingButton } from '@mui/lab';
import SendIcon from '@mui/icons-material/Send';


let display = "";
let thPadding = "16px";

if (window.innerWidth < 700) {
  display = "block";
  thPadding = "5px";

} else {
  display = "flex";
}
const tableStyle = css`
  z-index: 99;
  border: 1px solid #b0b0b07c;
  margin-top: 120px;
  width: 30vw;
  max-height: calc(100vh - 200px);
  #gabege {
    display: none;
    width: 25px;
    height: 25px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #gabege :hover {
    padding: 10px;
    border-radius: 100%;
    background-color: #e5e5e5;
  }
`;

const addOriginalSentenceArea = css`
  display: ${display};
  .addBtn {
    cursor: pointer;
    width: 100px;
    height: 50px;
    border-radius: 10%;
    margin-left: 35vw;
  }
  .sentence {
    display: ${display === "block" ? "none" : "block"};
    width: 50vw;
    margin-left: 200px;
  }
  .honeycomb {
    z-index: 1;
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  div {

    display: ${display};
    flex-direction: column;
    .css-y8ay40-MuiTableCell-root {
      padding-top: ${thPadding};
      padding-bottom: ${thPadding};
    }
  }

`;

const sentenceSelectStyle = css`
  float: left;
`;


export default function AddOriginalSentence(props) {
  const [loading, setLoading] = useState(false);
  const [sentenceIdState, setSentenceIdState] = React.useState(1);
  const [rows, setRows] = useState([])
  useEffect(() => {
    updateSentenceData();
  }, [])
  const updateSentenceData = async () => {

    const originalSentenceData = await getOriginalSentence(props.teacherId);
    let tmpArr = [...rows];
    if (originalSentenceData && !originalSentenceData.id) {
      tmpArr = []
      for (let i = 1; i <= Object.keys(originalSentenceData).length; i++) {
        tmpArr.push({
          "sentence": originalSentenceData[i]['completed_english_sentence'],
          "sentenceID": i,
        });
      }
    }
    setRows(tmpArr);

  }
  const wordsInit = {
    sentence: "",
    whoTop: "",
    whoBottom: "",
    doTop: "",
    doBottom: "",
    whatTop: "",
    whatBottom: "",
    howTop: "",
    howBottom: "",
    whereTop: "",
    whereBottom: "",
    whenTop: "",
    whenBottom: "",
    whyTop: "",
    whyBottom: "",
  }
  const [words, setWords] = useState({
    sentence: "",
    whoTop: "",
    whoBottom: "",
    doTop: "",
    doBottom: "",
    whatTop: "",
    whatBottom: "",
    howTop: "",
    howBottom: "",
    whereTop: "",
    whereBottom: "",
    whenTop: "",
    whenBottom: "",
    whyTop: "",
    whyBottom: "",
  });

  // form が更新されたら
  const handleChange = (e, position) => {
    const tmp = words;
    tmp[position] = e.target.value;
    setWords({ ...tmp });
  }


  let numberSelect;
  if (window.innerWidth > 700) {
    numberSelect = <TextField
      onChange={(e) => {
        if (1 <= e.target.value && e.target.value <= 300) {
          setSentenceIdState(e.target.value);
        }

      }}
      label="1-300"
      id="selectNumber"
      type='number'
      sx={{
        m: 1, width: '90px', marginTop: "50px"
      }}

      inputProps={{
        min: 0, max: 300
      }
      }
    />;
  }


  return (
    <>
      <div css={addOriginalSentenceArea}>

        <div>
          <div className='sentence'>
            <TextField
              value={words.sentence}
              onChange={(e) => {
                handleChange(e, "sentence");
              }}
              id="standard-size-normal"
              label="sentence"

              variant="standard"
              inputProps={{ style: { textAlign: 'center', fontSize: "2em" } }}
              sx={{ marginTop: "50px", textAlign: 'center' }}
            />
          </div>

          <div className='honeycomb'>
            <Honeycomb
              whatTop={<TextField
                value={words.whatTop}
                onChange={(e) => {
                  handleChange(e, "whatTop");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "20px", fontSize: "1.5em" }}
              />}
              whatBottom={<TextField
                onChange={(e) => {
                  handleChange(e, "whatBottom");
                }}
                value={words.whatBottom}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "0px", fontSize: "1.5em", transform: "translateY(-15px)" }}
              />}
              howTop={<TextField
                value={words.howTop}
                onChange={(e) => {
                  handleChange(e, "howTop");
                }}
                id="standard-size-normal"
                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "65px", fontSize: "1.5em" }}
              />}
              doTop={<TextField
                value={words.doTop.replace(" ", "　")}
                onChange={(e) => {
                  handleChange(e, "doTop");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "20px", fontSize: "1.5em" }}
              />}
              doBottom={<TextField
                value={words.doBottom}
                onChange={(e) => {
                  handleChange(e, "doBottom");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "0px", fontSize: "1.5em", transform: "translateY(-15px)" }}
              />}
              whereTop={<TextField
                value={words.whereTop}
                onChange={(e) => {
                  handleChange(e, "whereTop");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "20px", fontSize: "1.5em" }}
              />}
              whereBottom={<TextField
                value={words.whereBottom}
                onChange={(e) => {
                  handleChange(e, "whereBottom");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "0px", fontSize: "1.5em", transform: "translateY(-15px)" }}
              />}
              whenTop={<TextField
                value={words.whenTop}
                onChange={(e) => {
                  handleChange(e, "whenTop");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "20px", fontSize: "1.5em" }}
              />}
              whenBottom={<TextField
                value={words.whenBottom}
                onChange={(e) => {
                  handleChange(e, "whenBottom");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "0px", fontSize: "1.5em", transform: "translateY(-15px)" }}
              />}
              whyTop={<TextField
                value={words.whyTop}
                onChange={(e) => {
                  handleChange(e, "whyTop");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "65px", fontSize: "1.5em" }}
              />}
              whoTop={<TextField
                value={words.whoTop}
                onChange={(e) => {
                  handleChange(e, "whoTop");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "20px", fontSize: "1.5em" }}
              />}
              whoBottom={<TextField
                value={words.whoBottom}
                onChange={(e) => {
                  handleChange(e, "whoBottom");
                }}
                id="standard-size-normal"

                variant="standard"
                inputProps={{ style: { textAlign: 'center', fontSize: "1.5em" } }}
                sx={{ marginTop: "0px", fontSize: "1.5em", transform: "translateY(-15px)" }}
              />}
            />
            {
              loading ? (
                <LoadingButton
                  className='addBtn'
                  endIcon={<SendIcon />}
                  loading={loading}
                  loadingPosition="center"
                  variant="contained"
                  sx={{ borderColor: 'gray', color: "#555", width: '55px', height: '55px', marginLeft: '15px', padding: '0 5px' }}
                >
                </LoadingButton>
              ) : (

                <button className='addBtn' onClick={async () => {
                  setLoading(true);
                  if (words['doTop'].split("　").length === 1) {
                    words['doTop'] = words['doTop'] + "　";
                  }
                  await addOriginalSentence(props.teacherId, words);
                  await updateSentenceData();
                  setWords(wordsInit);
                  setLoading(false);
                }}>追加</button>
              )
            }
          </div>

        </div>
        <div css={sentenceSelectStyle}>

          <TableContainer component={Paper} css={tableStyle}>
            <Table aria-label="simple table"
              stickyHeader
              style={{
                tableLayout: "fixed",

              }}>

              <TableHead >
                <TableRow
                  sx={{ height: "50px" }}
                >

                  <TableCell style={{ width: 20 }}></TableCell>
                  <TableCell style={{ width: 20 }}>id</TableCell>
                  <TableCell >基本文</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, i) => (

                  <TableRow
                    key={row.sentenceID}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    onClick={() => {
                      setSentenceIdState(row.sentenceID);
                    }}
                  >

                    <TableCell value={i} component="th" scope="row" sx={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                      {
                        loading ? (
                          <div style={{ width: '15px', height: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <LoadingButton
                              key={row.sentenceID}

                              endIcon={<SendIcon />}
                              loading={loading}
                              loadingPosition="center"
                              variant="contained"
                              sx={{ borderColor: 'gray', color: "#555" }}
                            >
                            </LoadingButton>
                          </div>
                        ) : (
                          <div id='gabege' key={row.sentenceID}
                            onClick={async (e) => {
                              setLoading(true);
                              await deleteOriginalSentence(props.teacherId, i + 1)
                              // 更新
                              await updateSentenceData();
                              setLoading(false);
                            }}
                          ><DeleteIcon /></div>
                        )
                      }

                    </TableCell>
                    <TableCell >{row.sentenceID}</TableCell>

                    <TableCell key={row.sentenceID}>{row.sentence}</TableCell>
                  </TableRow>

                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </div>
      </div >
    </>
  );
}
